module.exports = __webpack_public_path__ + "img/Disease.20aed05b.png";